import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Wordmark from "./Wordmark";
import Footer from "./Footer";

/**
 * Shell for every non-home route. Keeps the wordmark visible so the
 * dashboard is always one click away — the "persistent home affordance"
 * called out in 02_SITEMAP_AND_NAVIGATION.md §"Navigation behaviour rules".
 */
export default function SiteShell({ children, showBack = true }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
      data-testid="site-shell"
    >
      <header
        style={{
          padding: "22px clamp(20px, 5vw, 60px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          zIndex: 40,
          backdropFilter: "blur(14px)",
          background: "rgba(10, 22, 40, 0.72)",
          borderBottom: "1px solid var(--line)",
        }}
      >
        <Wordmark />
        {showBack && (
          <Link
            to="/"
            data-testid="back-to-dashboard"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              color: "var(--text-dim)",
              textDecoration: "none",
              fontSize: 13.5,
              padding: "8px 14px",
              borderRadius: 999,
              border: "1px solid var(--line)",
              transition: "color 200ms, border-color 200ms",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "var(--gold-soft)";
              e.currentTarget.style.borderColor = "var(--line-strong)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "var(--text-dim)";
              e.currentTarget.style.borderColor = "var(--line)";
            }}
          >
            <ArrowLeft size={14} /> Back to the dashboard
          </Link>
        )}
      </header>

      <main style={{ flex: 1, position: "relative" }}>{children}</main>

      <Footer />
    </div>
  );
}
